import Vue from "vue";
import "./plugins/axios";
import "./assets/styles/main.scss";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import "nprogress/nprogress.css";
import vuelidate from "vuelidate";
import vueRx from "vue-rx";

import { TiptapVuetifyPlugin } from "tiptap-vuetify";

import VueAuthenticate from "vue-authenticate";
import VueGTag from "vue-gtag";
import VueGTagManager from "vue-gtm";

Vue.use(vueRx);
Vue.use(vuelidate);

Vue.use(TiptapVuetifyPlugin, {
    vuetify,
    iconsGroup: "mdi"
});

Vue.use(VueAuthenticate, {
    baseUrl: process.env.VUE_APP_ROOT_API,
    providers: {
        linkedin: {
            clientId: process.env.VUE_APP_LINKEDIN_CLIENT_ID,
            requiredUrlParams: ["state", "scope"],
            scope: ["r_emailaddress", "r_liteprofile"],
            url: "user/social"
        },
        google: {
            clientId: process.env.VUE_APP_GOOGLE_CLIENT_ID,
            url: "user/social"
        }
    }
});

Vue.config.productionTip = false;

Vue.use(VueGTag, {
    config: { id: process.env.VUE_APP_GOOGLE_ANALYTICS_ID_TRABAJOCONSENTIDO },
    includes: [
        { id: process.env.VUE_APP_GOOGLE_ANALYTICS_ID_PEGASCONSENTIDO },
    ]
}, router);

Vue.use(VueGTagManager, {
    id: process.env.VUE_APP_GOOGLE_GTM_ID_PEGASCONSENTIDO, // Your GTM single container ID or array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy']
    defer: false, // defaults to false. Script can be set to `defer` to increase page-load-time at the cost of less accurate results (in case visitor leaves before script is loaded, which is unlikely but possible)
    debug: false, //process.env.NODE_ENV !== "production", // Whether or not display console logs debugs (optional)
    loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
    vueRouter: router, // Pass the router instance to automatically sync with router (optional)
    trackOnNextTick: false, // Whether or not call trackView in Vue.nextTick
});

new Vue({
    created() {
        if (window.location.host == "www.pegasconsentido.cl") {
            window.location.href = "https://www.trabajoconsentido.com";
        }
    },
    router,
    store,
    vuetify,
    render: h => h(App)
}).$mount("#app");
